import * as yup from "yup";

export const validationSchemaDrivers = (translations: any) => yup.object().shape({
  lastName: yup.string().required(translations.lastNameRequired).max(50),
  firstName: yup.string().required(translations.firstNameRequired).max(50),
  phone: yup
    .string()
    .required(translations.phoneRequired)
    .matches(/^[0-9]+$/, translations.phoneInvalid)
    .min(9, translations.phoneInvalid)
    .max(9, translations.phoneInvalid),
  email: yup
    .string()
    .email(translations.emailInvalid)
    .required(translations.emailRequired)
    .max(50),
});
